import { Config } from '@oscar/request';
import { Button, Dropdown, Icon, Menu, MenuItem, OSLayout } from '@oscar/theme';
import { TYPE_OF_WORK } from 'common/constants/insulation';
import { Message } from 'features/application';
import {
  AuthProvider,
  Profile,
  SwitchedRoleDropdown,
  useAuth,
} from 'features/auth';
import React, { Component } from 'react';
import { BrowserRouter as Router, Link } from 'react-router-dom';
import routes, { authorized } from 'routes';
import './style.scss';
// APM route instrumentation can be added per Route if needed; wrapper removed to avoid react-router invariant.

const CreateButtons = () => {
  const [auth] = useAuth();
  const menuBtnCreateItems = (
    <Menu style={{ fontSize: '16px' }}>
      {TYPE_OF_WORK.map((item: any) => {
        return (
          <Menu.Item
            icon={<Icon icon={`${item.icon}`} size={22} />}
            key={item.id}
          >
            {item.link.startsWith('https://') ? (
              <a
                href={item.link}
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: 'none' }}
              >
                <span style={{ fontWeight: 600 }}>{item.tilte}</span>
                <br />
                <span className="title-item">{item.label}</span>
              </a>
            ) : (
              <Link to={`/insulation/create?type=${item.link}`}>
                <span style={{ fontWeight: 600 }}>{item.tilte}</span>
                <br />
                <span className="title-item">{item.label}</span>
              </Link>
            )}
          </Menu.Item>
        );
      })}
    </Menu>
  );

  return (
    <div className="header-left">
      <SwitchedRoleDropdown />
      {auth.checkRole('DRAFT', 'CREATED') ? (
        <Dropdown
          overlay={menuBtnCreateItems}
          placement="bottomRight"
          trigger={['click']}
        >
          <Button className="btn-create-request">
            Create Request&ensp;
            <Icon icon="arrow-down" size={8} color="#ffffff" />
          </Button>
        </Dropdown>
      ) : null}
    </div>
  );
};

const SettingButton = (changeTab: any) => {
  const configSettingButton = [
    {
      key: 'user',
      title: 'User',
      link: '/setting/user',
    },
    {
      key: 'service-provider',
      title: 'Service Provider',
      link: '/setting/service-provider',
    },
  ];
  const [auth] = useAuth();
  const menuBtnSettings = (
    <Menu style={{ fontSize: '16px' }}>
      {configSettingButton.map((item: any) => {
        return (
          <Menu.Item key={item?.key} onClick={() => changeTab('setting')}>
            <Link to={`${item?.link}`}>
              <div className="setting-item">{item?.title}</div>
            </Link>
          </Menu.Item>
        );
      })}
    </Menu>
  );

  return auth.getUserRoles().includes('ADMIN') ? (
    <Dropdown
      overlay={menuBtnSettings}
      trigger={['click']}
      placement="bottomRight"
    >
      <div className="btn-setting">Setting&ensp;</div>
    </Dropdown>
  ) : null;
};

const CheckRoleToVisible = (role: any) => {
  const [auth] = useAuth();
  if (auth.getUserRoles().includes('ADMIN')) {
    return true;
  }
  return !auth.getUserRoles().includes(role) ? true : false;
};

export default class Root extends Component {
  onRenderItem = ({ key, title, link = '#' }: MenuItem) => {
    return (
      <Link to={link} key={key}>
        {title}
      </Link>
    );
  };

  onRenderItemHeader = (
    { key, title, link = '#', component }: MenuItem,
    handleTab: any,
  ) => {
    if (component) {
      return component(handleTab);
    }
    if (link.includes('https://')) {
      return CheckRoleToVisible('CONTRACTOR') ? (
        <a key={key} href={link} target="_blank" style={{ color: 'white' }}>
          {title}
        </a>
      ) : null;
    }
    return (
      <Link to={link} key={key} style={{ color: 'white' }}>
        <div>{title}</div>
      </Link>
    );
  };

  render() {
    return (
      <Router>
        <AuthProvider>
          <div className="oscar-layout">
            <Message />
            {Config.getInstance().getTokenValue() ? (
              <OSLayout
                onRenderItem={this.onRenderItem}
                hiddenNav
                navItems={[
                  {
                    title: 'Sample',
                    key: 'samples',
                    // icon: Icons.UserOutlined,
                    submenu: [
                      {
                        title: 'Tables',
                        key: 'table',
                        link: '/table',
                      },
                      {
                        title: 'Create Insulation Request',
                        key: 'reateInsulation',
                        link: '/create',
                      },
                    ],
                  },
                ]}
                onRenderItemHeader={this.onRenderItemHeader}
                headerConfig={{
                  leftConfig: [
                    {
                      title: 'Home',
                      key: 'home',
                      link: '/',
                    },
                    {
                      title: 'Requests',
                      key: 'requests',
                      link: '/requests',
                    },
                    {
                      title: 'Performance',
                      key: 'performance',
                      link: 'https://app.powerbi.com/links/Vv8Os9LuLs?ctid=3b2e8941-7948-4131-978a-b2dfc7295091&pbi_source=linkShare&bookmarkGuid=ec6c9df0-7427-475b-b374-1a44441202d9',
                    },
                    {
                      title: 'Setting',
                      key: 'setting',
                      component: SettingButton,
                    },
                  ],
                  profileComponent: <Profile />,
                  notice: {
                    numberNotice: 4,
                  },
                }}
                onRenderMenuCreateItem={CreateButtons}
              >
                {routes}
              </OSLayout>
            ) : (
              <div>{authorized}</div>
            )}
          </div>
        </AuthProvider>
      </Router>
    );
  }
}
